module.exports = __webpack_public_path__ + "fc512706c5dbb6f93019e51c1b5bd4d6.MP3";